import { render, staticRenderFns } from "./new-quote.vue?vue&type=template&id=687080f8&scoped=true&"
import script from "./new-quote.vue?vue&type=script&lang=js&"
export * from "./new-quote.vue?vue&type=script&lang=js&"
import style0 from "./new-quote.vue?vue&type=style&index=0&id=687080f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687080f8",
  null
  
)

export default component.exports